/**
 * @generated SignedSource<<6b289ba6c3a823e225bd4909b818d60e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BaselineVersionScaleDirection = "FEWER" | "MORE" | "%future added value";
export type BaselineVersionSource = "COPY" | "COPY_SCALED" | "TEMPLATE" | "%future added value";
export type CreateBaselineVersionInput = {
  projectId: string;
  source: BaselineVersionSource;
  scaleDirection?: BaselineVersionScaleDirection | null;
  scalePercent?: number | null;
  templateId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateBaselineVersionMutation$variables = {
  input: CreateBaselineVersionInput;
};
export type CreateBaselineVersionMutation$data = {
  readonly createBaselineVersion: {
    readonly baselineVersion: {
      readonly id: string;
    } | null;
    readonly project: {
      readonly id: string;
    } | null;
  } | null;
};
export type CreateBaselineVersionMutation = {
  variables: CreateBaselineVersionMutation$variables;
  response: CreateBaselineVersionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateBaselineVersionPayload",
    "kind": "LinkedField",
    "name": "createBaselineVersion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BaselineVersion",
        "kind": "LinkedField",
        "name": "baselineVersion",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateBaselineVersionMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateBaselineVersionMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "3e2a721679fc407adb28d81f4dbe6afd",
    "id": null,
    "metadata": {},
    "name": "CreateBaselineVersionMutation",
    "operationKind": "mutation",
    "text": "mutation CreateBaselineVersionMutation(\n  $input: CreateBaselineVersionInput!\n) {\n  createBaselineVersion(input: $input) {\n    baselineVersion {\n      id\n    }\n    project {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f4c157fd3fe99c492549a00eedb6e5ce";

export default node;
